import { Employee } from "0.Mine/3.Interfaces/Employee";
import { BusinessService } from "0.Mine/3.Interfaces/Services";
import React, { memo } from "react";

import { useAddEmployeeFormLogic } from "../Logic/AddEmployee";
import AddEmployeeFormUI from "../UI/BusinessAddEmployee";

export interface AddEmployeeFormProps {
  show: boolean;
  onAdd: (employee: Employee) => void;
  defaultSchedule: any;
  employees: Employee[];
  ALL_AVAILABLE_SERVICES: BusinessService[];
}

const AddEmployeeForm: React.FC<AddEmployeeFormProps> = ({
  show,
  onAdd,
  defaultSchedule,
  employees,
  ALL_AVAILABLE_SERVICES,
}) => {
  const {
    newEmployee,
    handleFieldChange,
    handleServiceChange,
    handleAddService,
    handleRemoveService,
    handleAddEmployee,
    availableServices,
    selectedService,
    handleServiceSelection,
  } = useAddEmployeeFormLogic({ onAdd, defaultSchedule, employees, ALL_AVAILABLE_SERVICES });

  return (
    <AddEmployeeFormUI
      availableServices={availableServices}
      handleServiceChange={handleServiceSelection}
      show={show}
      newEmployee={newEmployee}
      onFieldChange={handleFieldChange}
      onServiceChange={handleServiceChange}
      onAddService={handleAddService}
      onRemoveService={handleRemoveService}
      onAddEmployee={handleAddEmployee}
    />
  );
};

export default memo(AddEmployeeForm);
